import { useEffect, useRef } from "react";

/**
 * useBodyScrollLock — V8.5.2 (reforçado)
 * Trava scroll do body + html, previne overscroll touch e mantém scroll position.
 * Reforçado contra Capacitor/iOS Safari onde inputs em iframe (Brick MP) podem
 * roubar foco e arrastar a página por baixo do modal.
 */
export default function useBodyScrollLock(locked) {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (!locked) return;
    const body = document.body;
    const html = document.documentElement;
    scrollYRef.current = window.scrollY || window.pageYOffset || 0;
    const sy = scrollYRef.current;

    const prev = {
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyWidth: body.style.width,
      bodyOverscroll: body.style.overscrollBehavior,
      bodyTouchAction: body.style.touchAction,
      htmlOverflow: html.style.overflow,
      htmlOverscroll: html.style.overscrollBehavior,
    };

    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${sy}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overscrollBehavior = "contain";
    body.style.touchAction = "none";
    html.style.overflow = "hidden";
    html.style.overscrollBehavior = "contain";

    // Bloqueia touchmove no document EXCETO dentro de elementos com data-scroll-lock-allow
    const onTouchMove = (e) => {
      let node = e.target;
      while (node && node !== document.body) {
        if (node.dataset && node.dataset.scrollLockAllow === "true") return;
        if (typeof node.closest === "function" && node.closest("[data-scroll-lock-allow=true]")) return;
        node = node.parentNode;
      }
      // Se chegou aqui sem encontrar área scrollable autorizada, bloqueia
      if (e.cancelable) e.preventDefault();
    };
    document.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      body.style.overflow = prev.bodyOverflow;
      body.style.position = prev.bodyPosition;
      body.style.top = prev.bodyTop;
      body.style.left = "";
      body.style.right = "";
      body.style.width = prev.bodyWidth;
      body.style.overscrollBehavior = prev.bodyOverscroll;
      body.style.touchAction = prev.bodyTouchAction;
      html.style.overflow = prev.htmlOverflow;
      html.style.overscrollBehavior = prev.htmlOverscroll;
      document.removeEventListener("touchmove", onTouchMove);
      window.scrollTo(0, sy);
    };
  }, [locked]);
}
